module.exports = __webpack_public_path__ + "assets/img/1.65e7dd96.jpg";